import { Component, OnInit, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { ScrollService, PlatformService } from '@app/data';

@Component({
  selector: 'app-is-in-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './is-in-view.component.html',
  styleUrls: ['./is-in-view.component.less']
})
export class IsInViewComponent implements OnInit {

  private scrollPosition$ = this.scroll.scrollPosition$;
  private unsubscribe$: Subject<void> = new Subject();
  private isBrowser = this.platform.isBrowser;
  private isInView = false;

  constructor(
    private platform: PlatformService,
    private host: ElementRef,
    private scroll: ScrollService
  ) {

    if (this.isBrowser) {
      this.scrollPosition$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
        //console.log('IsInViewComponent setShow data ', data);

        const rect = this.host.nativeElement.getBoundingClientRect();
        //console.log('IsInViewComponent setShow rect.top ', rect.top);        
        this.checkPosition(rect);
      });
    }
  }

  ngOnInit(): void {
    //console.log('IsInViewComponent ngOnInit this.show ', this.show);

    if (this.isBrowser) {
      const rect = this.host.nativeElement.getBoundingClientRect();
      //console.log('IsInViewComponent ngOnInit rect ', rect);
      this.checkPosition(rect); 
    }
  }

  ngOnDestroy(): void {
    //console.log('SearchContentComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    
  }

  private checkPosition(rect: any) {
    const isInView = rect.top >= 0;

    if(isInView !== this.isInView) {
      this.isInView = isInView;
      this.scroll.isInView({
        isInView,
        top: rect.top
      });
    }
  }
}
